import { camelCase, lowerCase } from 'es-toolkit';
import { startCase } from 'es-toolkit/compat';

export function convertKebabCaseToPascalCase(str: string) {
  if (!str) return str;
  const camelCaseStr = camelCase(str);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- FIXME: This rule was recently enabled for the repo
  return camelCaseStr[0]!.toUpperCase() + camelCaseStr.slice(1);
}

export function convertPascalCaseToSentenceCase(str: string) {
  if (!str) return str;
  const startCaseStr = startCase(str);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- FIXME: This rule was recently enabled for the repo
  return startCaseStr[0]!.toUpperCase() + lowerCase(startCaseStr.slice(1));
}

export function convertSnakeCaseToSentenceCase(str: string) {
  const startCaseStr = startCase(str);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- FIXME: This rule was recently enabled for the repo
  return startCaseStr[0]!.toUpperCase() + lowerCase(startCaseStr.slice(1));
}

/**
 *  Note -- This is a simplistic conversion, as it uses uppercase for every word. Conjunctions and prepositions will not be lowercased.
 */
export function convertPascalCaseToTitleCase(str: string) {
  if (!str) return str;
  return startCase(str);
}

export function convertPascalCaseToKebabCase(str: string) {
  if (!str) return str;
  return str.replace(/([a-z0–9])([A-Z])/g, '$1-$2').toLowerCase();
}

/**
 *  Note -- This is a simplistic conversion, as it uses uppercase for every word. Conjunctions and prepositions will not be lowercased.
 */
export function convertSnakeCaseToTitleCase(str: string) {
  const titleCaseString = startCase(str);
  return titleCaseString.replace(/\b\w/g, (char) => char.toUpperCase());
}
